import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { sop } from "ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/ph-bhp-view-sop/sop";
import { PHBHPLayoutPackageService } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { TranslationKeys } from "ph-bhp-localization";

@Component({
  selector: "app-sop-selection-by-type",
  templateUrl: "./sop-selection-by-type.component.html",
  styleUrls: ["./sop-selection-by-type.component.css"],
})
export class SOPSelectionByTypeComponent implements OnInit {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  @Input() institution: any;
  @Input() saSOPS: any = [];
  @Input() caSOPS: any = [];
  @Output() sopChecked = new EventEmitter<Array<number>>();

  selectAllCheckedForCountry: Set<string> = new Set<string>();
  searchTextSA: string;
  searchTextCA: string;
  allSAChecked: boolean = false;
  allCAChecked: boolean = false;

  constructor(
    private layoutService: PHBHPLayoutPackageService,
  ) {}

  ngOnInit(): void {
    if(!this.institution){
      this.institution = {institution : {listofSOPID : []}};
    }
  }
 
  checkAll(ev, type: string) {
    const checked = ev.target.checked;
    let sopsArray = this.institution.institution.listofSOPID;

    if (checked) {
      if (type == "sa") {
        this.saSOPS.forEach((sop) => {
          let index = sopsArray.indexOf(sop.sopid);
          if (index == -1) {
            sopsArray.push(sop.sopid);
          }
        });
      } else {
        this.caSOPS.forEach((sop) => {
          let index = sopsArray.indexOf(sop.sopid);
          if (index == -1) {
            sopsArray.push(sop.sopid);
          }
        });
      }
    } else {
      if (type == "sa") {
        this.saSOPS.forEach((sop) => {
          let index = sopsArray.indexOf(sop.sopid);
          if (index != -1) {
            sopsArray.splice(index, 1);
          }
        });
      } else {
        this.caSOPS.forEach((sop) => {
          let index = sopsArray.indexOf(sop.sopid);
          if (index != -1) {
            sopsArray.splice(index, 1);
          }
        });
      }
    }
    this.institution.institution.listofSOPID = sopsArray;
  }

  checkOne(ev, sopid: number, type: string) {
    const checked = ev.target.checked;

    if (checked) {
      this.institution.institution.listofSOPID.push(sopid);
    } else {
      let sopsArray = this.institution.institution.listofSOPID;
      let indexOf = sopsArray.indexOf(sopid);
      sopsArray.splice(indexOf, 1);
      this.institution.institution.listofSOPID = sopsArray;
      type == "sa" ? (this.allSAChecked = false) : (this.allCAChecked = false);
    }
    if(type == "sa"){
      // this.allMasterChecked = this.institution.institution.listofSOPID.split(",").every(item => this.masterSops.some(obj => obj.sopid == (+item)));
      this.allSAChecked = document.querySelectorAll('input[type="checkbox"].sa:checked').length == this.saSOPS.length;
    }else{
      // this.allUserChecked = this.institution.institution.listofSOPID.split(",").every(item => this.userSops.some(obj => obj.sopid == (+item)));
      this.allCAChecked = document.querySelectorAll('input[type="checkbox"].ca:checked').length == this.caSOPS.length;
    }
    let a = 1;
  }

  showSOPCA(title: string) {
    if (this.searchTextCA && this.searchTextCA.length > 1){
      const trl = this.layoutService.translateText(title);
      return trl.toLowerCase().includes(this.searchTextCA.toLowerCase());
    }
    return true;
  }

  showSOPSA(title: string) {
    if (this.searchTextSA && this.searchTextSA.length > 1) {
      const trl = this.layoutService.translateText(title);
      return trl.toLowerCase().includes(this.searchTextSA.toLowerCase());
    } 
    return true;
  }


  isChecked(sopId: number) {
    return this.institution && this.institution.institution &&  this.institution.institution.listofSOPID.indexOf(sopId) !== -1;
  }
}
